import styled, { keyframes } from 'styled-components';
import maintenanceBg from 'assets/images/samm-maintenance-bg.webp';

const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(24px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.07); }
`;

export const PageWrapper = styled.div`
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${maintenanceBg});
    background-size: cover;
    background-position: top center;
`;

export const LogoImg = styled.img`
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 200px;
`;

export const Card = styled.div`
    background: #ffffff;
    border-radius: 20px;
    padding: 48px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 620px;
    min-height: 410px;
    max-width: 92vw;
    box-sizing: border-box;
    animation: ${fadeSlideUp} 0.45s ease both;

    @media (max-width: 660px) {
        padding: 36px 28px;
    }
`;

export const IconWrapper = styled.div`
    margin-bottom: 24px;
    line-height: 0;
    animation: ${pulse} 2.8s ease-in-out infinite;
`;

export const MainContent = styled.main`
    display: contents;
`;

export const Title = styled.h1`
    color: #1e2a5e;
    font-family: 'Open Sans', sans-serif;
    font-size: 40px;
    font-weight: 800;
    line-height: 100%;
    letter-spacing: -0.5px;
    margin: 0 0 16px;
`;

export const BodyText = styled.p`
    color: #4a4a4a;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0;
    margin: 0;
`;

export const ForecastText = styled.p`
    color: #4a4a4a;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0;
    margin: 8px 0 0;
`;

export const Bold = styled.strong`
    color: #1e2a5e;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0;
`;
